var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",class:[
    _vm.defaultClass,
    _vm.sizeClass,
    _vm.typeClass,
    _vm.variantClass,
    (_vm.tag === 'inertia-link' || _vm.tag === 'a') && 'inline-block' ]},'component',_vm.$attrs,false),_vm.$listeners),[_c('svg',{class:[_vm.small && 'h-4 w-auto', _vm.regular && 'h-5 w-auto', _vm.large && 'h-8 w-auto'],attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }